const Projects = () => {
    return (
        <div>
            <a href="https://your-universal-weight.netlify.app/">Your (Universal) Weight</a>
        </div>
    );
}
 
export default Projects;